export const environment = {
  production: false,
  evnName: 'Test Environment',
  appUrl: 'https://ideacoreaid.com/',
  apiUrl: 'https://api.ideacoreaid.com/',
  fileApiUrl: 'https://file.innercore.com.tr/',
  version: 'v.2.6',
  citizenMobileUrl: 'https://ideacoreaid.com/',
  callActionApiUrl: "http://10.13.0.136:8383/",
  callActionPrefix: "90",
  captchaSiteKey: '6LczuBgsAAAAAPtS2g7EltESvLns0mlz7RMtYf7h',
  callActionApiPassword: 'fE4d)V14qz_h',
  callActionApiUser: 'ideaCTIuser',
  openStreetMapApiKey: 'eyJvcmciOiI1YjNjZTM1OTc4NTExMTAwMDFjZjYyNDgiLCJpZCI6ImE5ZDk2YmFkZGMzMzQyZjRhNGZmOTYwZDI4YTVjYjJlIiwiaCI6Im11cm11cjY0In0=',
  googleCalendarApiKey: 'AIzaSyDcnW6WejpTOCffshGDDb4neIrXVUA1EAE',
  googleSearchApiKey: 'AIzaSyBvNbagCTzeEXOew9M6kTdyMdRe2rrBAeY'
};
